import Techrity from '../../assets/techrity.png';
import Gameverse from '../../assets/gameverse.png';

export const sponsorData = [
  {
    id: 1,
    name: "Techrity",
    image: Techrity
  },
  {
    id: 2,
    name: "Gameverse",
    image: Gameverse
  },
  {
    id: 3,
    name: "Techrity",
    image: Techrity
  },
  {
    id: 4,
    name: "Gameverse",
    image: Gameverse
  }
]